import React from 'react'
import logo from '../assets/img/logo.png'
import '../assets/css/Menu.css'
import { Link, NavLink } from 'react-router-dom';
import { fade, makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import MenuIcon from '@material-ui/icons/Menu';
import Button from '@material-ui/core/Button';
import clsx from 'clsx';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Grid from "@material-ui/core/Grid";
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
        marginLeft: theme.spacing(6),
        // backgroundColor:'red',
        "&:focus": {
            outline: 'none'
        },
        [theme.breakpoints.down('md')]: {
            marginLeft: theme.spacing(6),
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: theme.spacing(1),
        },
    },
    iconMenu: {
        // height: '5vw',
        width: '300px',
        // backgroundColor:'blue'
        [theme.breakpoints.down('md')]: {
            width: '250x',
        },
        [theme.breakpoints.down('sm')]: {
            width: '200px',
        },
    },
    title: {
        color: '#464545',
        display: 'none',
        fontSize: '1.25vw',
        fontFamily: 'Roboto-Regular',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
    headerButton: {
        textTransform: 'none',
        // backgroundColor:'blue',
        // height: '40px',
        marginRight: theme.spacing(4),
        marginTop: theme.spacing(1.29),
        "&:hover": {
            backgroundColor: 'transparent',
            borderBottom: "2.4px solid #04AB23",
            borderRadius: 0
        },
        display: 'none',
        [theme.breakpoints.up('lg')]: {
            display: 'flex',
        },
        "&:focus": {
            outline: 'none',
            backgroundColor: 'transparent',
            // borderBottom: "2px solid #04AB23",
            borderRadius: 0
        },
    },
    navStyle: {
        textTransform: 'none',
        color: 'red',
        fontFamily: 'Roboto-Regular',

    },

    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        backgroundColor: 'white',
        // height:'20vh'
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginRight: drawerWidth,

    },
    drawer: {
        // width: drawerWidth,
        flexShrink: 0,
        // display: 'flex',
        [theme.breakpoints.up('lg')]: {
            display: 'none',
            width: '0vw',
            flexShrink: 0,
        },
    },
    drawerPaper: {
        width: drawerWidth,
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-start',


    },
    hide: {
        display: 'none',
    },
    nested: {
        paddingLeft: theme.spacing(4)
    },
    CustomDropdown: {
        backgroundColor: 'red !important',
        color: 'red !important',
        "&:hover": {
            backgroundColor: 'yellow'
        }
    },
    dropdownbasicbutton: {
        display: 'none',
        marginRight: theme.spacing(5),
        
        "&:focus": {
            outline: 'none',
            backgroundColor: 'transparent',
            borderBottom: "2px solid #04AB23",
            borderRadius: 0
        },
        [theme.breakpoints.up('lg')]: {
            display: 'flex',
        },

    },
    dropdownItem: {

        "&:hover": {
            backgroundColor: 'green'
        },
        "&:active": {
            backgroundColor: 'green'
        }
    },

    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(3),
            width: 'auto',
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '20ch',
        },
    },
    sectionMobile: {
        display: 'flex',
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
        Toolbar: {
            WebkitBoxShadow: 'none',
            boxShadow: 'none',
            MozBoxShadow: 'none'
        }
    },
}));

const drawerWidth = 240;

export default function Menuu(props) {

    const classes = useStyles();
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    React.useEffect(() => {
        document.getElementById("hamburger").style.fill = "rgba(0, 0, 0, 0.54)"
    }, [])

    

    return (
        <ClickAwayListener onClickAway={handleDrawerClose}>
            <div className={classes.grow}>
                <AppBar position="fixed"
                    className={clsx(classes.appBar)}
                    id="Appbar"
                >
                    <Toolbar>
                        <Grid container>
                            <Grid item xs={3}>
                                <Button className={classes.menuButton}>
                                    <Link to="/">
                                        <img src={logo} alt="logo" className={classes.iconMenu} />
                                    </Link>
                                </Button>
                            </Grid>
                            <Grid item xs={9} style={{ marginTop: '1.3em', alignSelf: 'right' }}>
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                                    <NavLink 
                                        to="/Login"
                                        activeStyle={{ borderRadius: 0, borderBottom: "2.4px solid #04AB23" }}
                                        className={classes.headerButton}
                                    >
                                        <Typography className={classes.title}>
                                            Login
                                        </Typography>
                                    </NavLink>
                                </div>
                            </Grid>
                        </Grid>
                        <div className={classes.grow} />
                        <div className={classes.sectionMobile}>
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                edge="end"
                                onClick={handleDrawerOpen}
                                className={clsx(open && classes.hide)}
                            >
                                <MenuIcon id="hamburger" />
                            </IconButton>
                        </div>
                    </Toolbar>
                </AppBar >


                <Drawer
                    className={classes.drawer}
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                    anchor='right'
                    open={open}
                    onClose={handleDrawerClose}
                >
                    <div className={classes.drawerHeader}>
                        <IconButton onClick={handleDrawerClose}>
                            {theme.direction === 'rtl' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                        </IconButton>
                    </div>
                    <Divider />
                    <div role="presentation" onKeyDown={handleDrawerClose}>
                        <List component="nav">
                            <NavLink to="/Login" style={{ color: '#464545', fontFamily: 'Roboto-Regular', }} activeStyle={{ borderBottom: "2px solid #04AB23" }}>
                                <ListItem button>
                                    <ListItemText primary="Login" />
                                </ListItem>
                            </NavLink>

                        </List>
                    </div>
                </Drawer>
            </div >
        </ClickAwayListener>
    );
}
